import { ref, computed } from "vue"
import CartButton from '../CartButton/CartButton.vue'
import ProductCarousel from '../ProductCarousel/ProductCarousel.vue'
import InStockLabel from '../InStockLabel/InStockLabel.vue'
import { useStore } from 'vuex'

export default {
    name: "ProductSpot",
    components: {
        CartButton,
        ProductCarousel,
        InStockLabel
    },
    props: {
        productData: {
            default: {}
        },
        ambienceToggle: {
            default: false,
            type: Boolean
        }
    },
    setup(props) {

        const store = useStore()

        const displayingEnvironmentImage = ref(false)
        const environmentImageDisplayClass = computed(() => displayingEnvironmentImage.value ? 'nlx-product-spot__environment-image--visible' : '')
        const ambienceToggleModifier = computed(() => {
            return props.ambienceToggle && userIsLoggedIn.value ? 'nlx-product-spot--ambience-toggle nlx-user-logged-in' : props.ambienceToggle ? 'nlx-product-spot--ambience-toggle' : ''
        })
        const productDataSeemsValid = computed(() => !!(Object.keys(props.productData).length > 4))
        const productDataSet = computed(() => (Object.keys(props.productData).length > 4) ? props.productData : null)
        const userIsLoggedIn = computed(() => store.state.main.user_logged_in_status)
        const showRrp = computed(() => store.state.main.show_rrp)
        const productLabels = computed(() => {
          if (productDataSeemsValid.value && !!props.productData.labels) {
            return props.productData.labels;
          } else {
              return [];
          }
      });

        const displayEnvironmentImage = function(e) {
            displayingEnvironmentImage.value = true
        }

        const hideEnvironmentImage = function(e) {
            displayingEnvironmentImage.value = false
        }

        const hoverShotAvailable = !!(productDataSeemsValid.value && Array.isArray(productDataSet.value.hoverShotUrls) && !!productDataSet.value.hoverShotUrls.length)

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        return {
            ambienceToggleModifier,
            displayEnvironmentImage,
            environmentImageDisplayClass,
            getLabel,
            hideEnvironmentImage,
            hoverShotAvailable,
            productDataSet,
            userIsLoggedIn,
            showRrp,
            productLabels
        }
    }
}
